import React, { useState, useEffect } from 'react';
import { Button, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { CartFill, Cash, Truck, Trash } from 'react-bootstrap-icons';
import { useCarrito } from '../ventaUnidad/componenetes/CarritoContext';
import CarUni from '../ventaUnidad/componenetes/carUni';
import '../styles/BarCar.css';

function BarCar() {
    const [show, setShow] = useState(false);
    const { carrito, calculateShippingCost, calculateTotalWithDiscount, clearCarrito } = useCarrito();
    const [cartBounce, setCartBounce] = useState(false);

    const closeCar = () => setShow(false);
    const showCar = () => setShow(true);

    const totalItems = carrito.reduce((total, item) => total + item.quantity, 0);
    const envioCosto = calculateShippingCost();
    const totalConDescuento = calculateTotalWithDiscount();

    const renderTooltip = (text) => (
        <Tooltip>{text}</Tooltip>
    );

    const formatCop = (value) => value?.toLocaleString('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }) || '$0';

    useEffect(() => {
        if (totalItems > 0) {
            setCartBounce(true);
            setTimeout(() => setCartBounce(false), 500); // Duración de la animación
        }
    }, [totalItems]);

    return (
        <>
            <div className='bg-black w-100 d-flex justify-content-center align-items-center py-3 sticky-top z-3'>
                <div className='d-flex justify-content-between w-100 align-items-center'>
                    <OverlayTrigger placement="bottom" overlay={renderTooltip('Compra')}>
                        <Button variant='link' className='text-light flex-grow-1 mx-1 d-flex flex-column justify-content-center align-items-center text-decoration-none'>
                            <Cash size={24} />
                            <span>{formatCop(totalConDescuento)}</span>
                        </Button>
                    </OverlayTrigger>
                    <OverlayTrigger placement="bottom" overlay={renderTooltip('Envío')}>
                        <Button variant='link' className='text-light flex-grow-1 mx-1 d-flex flex-column justify-content-center align-items-center text-decoration-none'>
                            <Truck size={24} />
                            <span>{formatCop(envioCosto > 0 ? envioCosto : '$ 0')}</span>
                        </Button>
                    </OverlayTrigger>
                    <OverlayTrigger placement="bottom" overlay={renderTooltip('Carrito')}>
                        <Button
                            onClick={showCar}
                            variant='link'
                            className={`text-light flex-grow-1 mx-1 d-flex flex-column justify-content-center align-items-center text-decoration-none ${cartBounce ? 'cart-bounce' : ''}`}>
                            <CartFill size={24} />
                            <span>{totalItems}</span>
                        </Button>
                    </OverlayTrigger>
                    <OverlayTrigger placement="bottom" overlay={renderTooltip('Limpiar')}>
                        <Button
                            onClick={clearCarrito}
                            variant='link'
                            className='text-light flex-grow-1 mx-1 d-flex flex-column justify-content-center align-items-center text-decoration-none'>
                            <Trash size={24} />
                        </Button>
                    </OverlayTrigger>
                </div>
            </div>

            <CarUni show={show} handleClose={closeCar} />
        </>
    );
}

export default BarCar;
